export default "__VITE_ASSET__sNkFSo63__"